import styles from '../DavidPifView.module.css'
import classNames from 'classnames'
import { PayItForwardOutlineIcon } from '@/atoms/Icons/PayItForwardOutlineIcon'
import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

function IconWrapper({ icon, children }: { icon?: string; children?: React.ReactNode }) {
  return (
    <div className="relative flex size-[48px] shrink-0 content-stretch items-center justify-center gap-[8px] rounded-[100px] bg-[#c9edf2]">
      <div className={`relative ${icon === 'name' ? 'size-[26px]' : 'size-[24px]'} shrink-0`}>
        {children ? (
          <div className="flex size-full items-center justify-center">{children}</div>
        ) : (
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
            viewBox={icon === 'name' ? '0 0 24 16' : icon === 'contagious' ? '0 0 20 24' : '0 0 24 24'}
          >
            {icon === 'pay-forward' && (
              <path
                clipRule="evenodd"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                fill="var(--fill-0, #141447)"
                fillRule="evenodd"
              />
            )}
            {icon === 'name' && (
              <>
                <path
                  d="M24 15.4494H22.6679V13.7033H21.2367V15.4494H19.8984V10.8627H21.2367V12.5266H22.6679V10.8627H24V15.4494Z"
                  fill="#141447"
                />
                <path
                  d="M18.6069 11.9952H17.2501V15.4494H15.918V11.9952H14.6169V10.8627H18.421L18.6069 11.9952Z"
                  fill="#141447"
                />
                <path d="M13.2142 15.4494H11.8821V10.8627H13.2142V15.4494Z" fill="#141447" />
                <path
                  d="M10.3885 15.4494H9.03162L8.84575 12.6531L8.11465 15.4494H6.83214L6.09485 12.6531L5.91517 15.4494H4.76277L5.10973 10.8627H6.82594L7.60041 13.7602L8.37487 10.8627H10.0477L10.3885 15.4494Z"
                  fill="#141447"
                />
                <path
                  d="M3.51297 14.007C3.51297 15.0888 2.71373 15.5 1.75959 15.5C1.07806 15.5 0.526636 15.3608 0 15.1394L0.198263 14.0259C0.731095 14.2917 1.3011 14.4688 1.77817 14.4688C2.07557 14.4688 2.27383 14.3739 2.27383 14.1714C2.27383 13.9817 2.14992 13.8868 1.49317 13.6717C0.526636 13.3364 0.0991316 13.0327 0.0991316 12.2292C0.0991316 11.2866 0.842618 10.8121 1.77198 10.8121C2.44111 10.8121 2.85003 10.926 3.30232 11.1411L3.10406 12.2419C2.63318 11.9825 2.15611 11.8496 1.79676 11.8496C1.48697 11.8496 1.33828 11.9445 1.33828 12.1027C1.33828 12.2798 1.45599 12.3747 2.01361 12.5456C3.07927 12.8935 3.51297 13.2541 3.51297 14.007Z"
                  fill="#141447"
                />
                <path
                  d="M21.8516 5.16892H20.6744L19.0078 2.77752V5.16892H17.7687V0.582244H19.0821L20.6187 2.77752V0.582244H21.8516V5.16892Z"
                  fill="#141447"
                />
                <path
                  d="M16.1646 5.16892H14.8325V3.42282H13.4013V5.16892H12.063V0.582244H13.4013V2.2461H14.8325V0.582244H16.1646V5.16892Z"
                  fill="#141447"
                />
                <path
                  d="M10.624 2.87242C10.624 4.28321 9.7132 5.25749 8.31916 5.25749C6.93751 5.25749 6.02674 4.29587 6.02674 2.88507C6.02674 1.46162 6.93751 0.5 8.33155 0.5C9.71939 0.5 10.624 1.45529 10.624 2.87242ZM9.29809 2.87874C9.29809 2.05631 8.94493 1.53121 8.32536 1.53121C7.70578 1.53121 7.35882 2.05631 7.35882 2.87874C7.35882 3.70118 7.71198 4.22628 8.32536 4.22628C8.94493 4.22628 9.29809 3.70118 9.29809 2.87874Z"
                  fill="#141447"
                />
                <path
                  d="M4.62622 3.66322C4.62622 4.79566 3.90132 5.2132 2.96577 5.2132C2.66218 5.2132 2.37098 5.18157 2.24706 5.14994L2.07358 4.02383C2.21608 4.06179 2.35859 4.09975 2.63739 4.09975C3.03392 4.09975 3.29414 3.94791 3.29414 3.42914V0.582244H4.62622V3.66322Z"
                  fill="#141447"
                />
              </>
            )}
            {icon === 'contagious' && (
              <path
                d="M15.5 11.7499V13.9999C15.5 14.2832 15.4042 14.5207 15.2125 14.7124C15.0208 14.904 14.7833 14.9999 14.5 14.9999C14.2167 14.9999 13.9792 14.904 13.7875 14.7124C13.5958 14.5207 13.5 14.2832 13.5 13.9999V12.2749L12.375 10.2499C12.2583 10.3332 12.1667 10.4415 12.1 10.5749C12.0333 10.7082 12 10.8499 12 10.9999V16.7249L13.675 19.4999C13.875 19.8332 13.875 20.1665 13.675 20.4999C13.475 20.8332 13.1833 20.9999 12.8 20.9999C12.6167 20.9999 12.45 20.9582 12.3 20.8749C12.15 20.7915 12.0333 20.6749 11.95 20.5249L10 17.2999V10.9999C10 10.4832 10.125 10.0082 10.375 9.57488C10.625 9.14154 10.9667 8.78321 11.4 8.49988L10 6.02488C9.66667 5.39154 9.52084 4.72071 9.56251 4.01238C9.60417 3.30404 9.87501 2.69988 10.375 2.19988L11.325 1.27488C11.5417 1.05821 11.7917 0.954044 12.075 0.962377C12.3583 0.97071 12.5917 1.09154 12.775 1.32488L18.55 8.09988C18.6833 8.26654 18.7917 8.44571 18.875 8.63738C18.9583 8.82904 19.0083 9.03321 19.025 9.24988L19.9 19.9249C19.9333 20.2082 19.85 20.4582 19.65 20.6749C19.45 20.8915 19.2083 20.9999 18.925 20.9999C18.6583 20.9999 18.4333 20.9124 18.25 20.7374C18.0667 20.5624 17.9583 20.3415 17.925 20.0749L17.025 9.39988L11.95 3.44988L11.8 3.59988C11.6333 3.76654 11.5375 3.95821 11.5125 4.17488C11.4875 4.39154 11.525 4.59988 11.625 4.79988L15.5 11.7499ZM4.50001 11.7499L8.37501 4.79988C8.47501 4.59988 8.51251 4.39154 8.48751 4.17488C8.46251 3.95821 8.36667 3.76654 8.20001 3.59988L8.05001 3.44988L2.97501 9.39988L2.07501 20.0999C2.04167 20.3665 1.93334 20.5832 1.75001 20.7499C1.56667 20.9165 1.34167 20.9999 1.07501 20.9999C0.791674 20.9999 0.550008 20.8915 0.350008 20.6749C0.150008 20.4582 0.0666745 20.2082 0.100008 19.9249L0.975008 9.24988C0.991674 9.03321 1.04167 8.82904 1.12501 8.63738C1.20834 8.44571 1.31667 8.26654 1.45001 8.09988L7.22501 1.32488C7.40834 1.09154 7.64584 0.97071 7.93751 0.962377C8.22917 0.954044 8.48334 1.05821 8.70001 1.27488L9.62501 2.19988C10.125 2.69988 10.3958 3.30404 10.4375 4.01238C10.4792 4.72071 10.3333 5.39154 10 6.02488L8.60001 8.49988C9.03334 8.78321 9.37501 9.14154 9.62501 9.57488C9.87501 10.0082 10 10.4832 10 10.9999V17.2999L8.05001 20.5249C7.96667 20.6749 7.84584 20.7915 7.68751 20.8749C7.52917 20.9582 7.35834 20.9999 7.17501 20.9999C6.79167 20.9999 6.50417 20.8332 6.31251 20.4999C6.12084 20.1665 6.12501 19.8332 6.32501 19.4999L8.00001 16.7249V10.9999C8.00001 10.8499 7.96667 10.7082 7.90001 10.5749C7.83334 10.4415 7.74167 10.3332 7.62501 10.2499L6.50001 12.2749V13.9999C6.50001 14.2832 6.40417 14.5207 6.21251 14.7124C6.02084 14.904 5.78334 14.9999 5.50001 14.9999C5.21667 14.9999 4.97917 14.904 4.78751 14.7124C4.59584 14.5207 4.50001 14.2832 4.50001 13.9999V11.7499Z"
                fill="#141447"
              />
            )}
          </svg>
        )}
      </div>
    </div>
  )
}

function ListItem({
  icon,
  iconComponent,
  title,
  description,
}: {
  icon?: string
  iconComponent?: React.ReactNode
  title: string
  description: string
}) {
  return (
    <div className="relative flex w-full shrink-0 content-stretch items-start gap-[16px]" data-name="item">
      {iconComponent ? <IconWrapper>{iconComponent}</IconWrapper> : <IconWrapper icon={icon} />}
      <div className="relative flex min-h-px min-w-px shrink-0 grow basis-0 flex-col content-stretch items-start gap-[4px] not-italic">
        <p className="font-whitney-semibold relative w-full shrink-0 text-[18px] font-bold leading-[22px] text-white md:text-[20px] md:leading-[24px]">
          {title}
        </p>
        <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#c9edf2] md:text-[18px] md:leading-[28px]">
          {description}
        </p>
      </div>
    </div>
  )
}

export function HowItWorksSection() {
  const { t } = useTranslate('pif')

  return (
    <section
      className={classNames('relative w-full bg-[#141447] lg:!pb-[200px]', styles['section-lg'])}
      data-name="how-it-works"
    >
      <div
        className="relative mx-auto flex w-full max-w-[1440px] flex-col items-start gap-[40px] md:flex-col-reverse lg:flex-row-reverse lg:items-center lg:gap-[64px]"
        data-name="container-50"
      >
        <div
          className={classNames(
            'relative w-full grow-1 overflow-hidden rounded-3xl',
            styles['david-image-aspect-ratio'],
          )}
        >
          <Image
            loading="lazy"
            alt="David with his lamb"
            src="/v1760913576/theatrical/david/david-jonathan-img-02.webp"
            fill
            className="object-cover"
          />
        </div>
        <div className="relative w-full">
          <div className="flex size-full flex-col justify-center">
            <div className="relative flex w-full flex-col items-start justify-center gap-[40px]">
              <div className="relative flex w-full flex-col items-start gap-[12px] md:gap-[8px]">
                <p className="font-angel-royal relative w-full text-5xl lowercase not-italic leading-[2.5rem] text-white md:text-[3.5rem] md:leading-[3rem]">
                  {t('davidHowGiftReachesFamilies', 'How Your Gift Reaches Families')}
                </p>
                <div className="relative flex w-full flex-col items-start gap-[24px] px-0 pb-0 pt-[8px]">
                  <ListItem
                    iconComponent={<PayItForwardOutlineIcon size={24} color={'core-gray-900'} />}
                    title={t('davidYouPayItForward', 'You Pay It Forward')}
                    description={t(
                      'davidYouPayItForwardDesc',
                      "Your contribution buys tickets for families who wouldn't otherwise be able to go.",
                    )}
                  />
                  <ListItem
                    icon="contagious"
                    title={t('davidGenerosityContagious', 'Your Generosity is Contagious')}
                    description={t(
                      'davidGenerosityContagiousDesc',
                      'Your kindness inspires and encourages others to Pay it Forward.',
                    )}
                  />
                </div>
              </div>
              <div
                className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[8px] md:w-auto md:flex-row"
                data-name="button-set"
              >
                <DavidButton variant="cyan" href="#" className="w-full md:w-auto" openPifOverlay>
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
                <DavidButton variant="white" href="/tickets/david" className="w-full md:w-auto">
                  {t('getShowtimes', 'Get Showtimes')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
